import { Button, Card, Modal } from '@themesberg/react-bootstrap';
import { SUCCESS, APP_NAME, DANGER } from 'utils/constants/notifyTypes';

import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiCall, apiRoutes, getToaster } from 'utils/helpers';
import Loader from '../Loader';
import { store } from 'react-notifications-component';
import { config } from '../../config';
import jsonFormData from 'json-form-data';

export const CourseModal = ({ handleClose, editData }: { handleClose: any; editData?: any | null }) => {
    const dispatch = useDispatch();

    const [title, setTitle] = useState(editData?.title || '');
    const [shortDescription, setShortDescription] = useState(editData?.short_description || '');
    const [description, setDescription] = useState(editData?.description || '');
    const [uploadFile, setUploadFile] = useState<any>(null);

    const [errorMsg, setErrorMsg] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const addTestimonialFunc = async (payloadData: any) => {
        const options = {
            initialFormData: new FormData(),
            showLeafArrayIndexes: true,
            includeNullValues: true,
            mapping: function (value: string | number) {
                if (typeof value === 'boolean') {
                    return +value ? '1' : '0';
                }
                return value;
            },
        };

        const data = jsonFormData(payloadData, options);
        let response = null;
        if (payloadData?.id) {
            const url = { ...apiRoutes.updateCourse, data };
            url.apiPath = url.apiPath.replace(':courseId', payloadData?.id ? payloadData?.id.toString() : '');
            response = await apiCall(url);
        } else {
            response = await apiCall({ ...apiRoutes.addCourse, data });
        }

        if (response?.data?.status) {
            setIsLoading(false);
            handleClose();
            window.location.reload();
            store.addNotification(getToaster(`${APP_NAME} Course`, response?.data?.message, SUCCESS));
        } else {
            setIsLoading(false);
            store.addNotification(getToaster(`${APP_NAME} Course`, response?.data?.error[0], DANGER));
        }
    };

    const dispatchCustomer = useCallback(async () => {
        if (title === '' || shortDescription === '' || description === '') {
            setErrorMsg('Some fields are missing');
            return;
        }

        setErrorMsg('');
        const data = {
            id: editData?.id || null,
            title,
            short_description: shortDescription,
            description,
            uploadFile: uploadFile,
            is_enable: true,
        };
        setIsLoading(true);
        await addTestimonialFunc(data);
    }, [dispatch, editData, title, shortDescription, description, uploadFile]);

    return (
        <>
            {isLoading ? <Loader isLoad /> : null}
            <Modal show={true} onHide={handleClose} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Course</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {errorMsg && (
                        <div className="alert alert-danger" role="alert">
                            {errorMsg}
                        </div>
                    )}
                    <div className="col-12">
                        <input
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            type="text"
                            placeholder="Name"
                            className="form-control"
                        />
                    </div>

                    <div className="col-12 mt-2">
                        <input
                            onChange={(e) => setShortDescription(e.target.value)}
                            value={shortDescription}
                            type="text"
                            placeholder="Short Description"
                            className="form-control"
                        />
                    </div>
                    <div className="col-12 mt-2">
                        <input
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                            type="text"
                            placeholder="Content"
                            className="form-control"
                        />
                    </div>
                    <div className="col-12 mt-2">
                        <input
                            onChange={(e: any) => {
                                const files = e.target.files;
                                const file = files.length ? files[0] : null;
                                setUploadFile(file);
                            }}
                            type="file"
                            placeholder="Content"
                            className="form-control"
                        />
                        {editData?.file_path ? (
                            <Card border="light" className="text-center p-0 mb-4">
                                <div
                                    style={{ backgroundImage: `url(${config.apiBaseURL}/${editData?.file_path})` }}
                                    className="profile-cover rounded-top"
                                />
                            </Card>
                        ) : null}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button onClick={() => dispatchCustomer()} variant="primary">
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
